<template>
    <div class="page">
        <transition name="fade-transition">
            <v-container v-if="walletData">
                <div>
                    <v-alert v-if="success" dense color="success" outlined dismissible>
                        <div class="strong-text--text details-text">
                            <v-icon color="success" class="me-2">mdi-check-circle</v-icon>
                            <span>Wallet has been recharged successfully.</span>
                        </div>
                    </v-alert>
                    </div>
                <v-card v-if="appData" class="px-3 pb-1 mb-4 primary--text" style="border: 1px solid!important; max-width: 625px">
                    <v-card-text>
                        <div class="d-flex w-100 justify-space-between" :class="{'flex-column': phoneOnly}">
                            <div class="text-left flex-grow-1">
                                <div class="d-flex align-center">
                                    <div class="me-4">
                                        <v-avatar size="64" class="primary--text" style="border: 2px solid;">
                                            <v-icon size="36" color="primary">mdi-wallet</v-icon>
                                        </v-avatar>
                                    </div>
                                    <div class="mb-2">
                                        <div class="strong-text--text mb-2">
                                            Balance
                                        </div>
                                        <h1 class="strong-text--text font-weight-bold">{{moneyFormat(user.balance, true)}}</h1>
                                    </div>
                                </div>
                            </div>
                            <div :class="{'mt-2': phoneOnly}">
                                <v-btn depressed color="primary" @click="rechargeDialog = true;">
                                    <v-icon left>mdi-wallet-plus-outline</v-icon>
                                    <span>Recharge</span>
                                </v-btn>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>

                <v-card :flat="phoneOnly" class="px-2 px-lg-3 bordered">
                    <v-card-title class="d-flex justify-space-between">
                        <div>
                            Wallet History
                        </div>
                        <div class="px-3">
                            
                        </div>
                    </v-card-title>
                    <v-card-subtitle>History of your wallet transactions and payments</v-card-subtitle>
                    <v-card-text v-if="!loadingTransactions" :class="{'px-0': phoneOnly}">
                        <v-simple-table v-if="items && items.length" class="e-data-table">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">
                                            ID
                                        </th>
                                        <th class="text-left">
                                            Details
                                        </th>
                                        <th class="text-left">
                                            Amount
                                        </th>
                                        <th class="text-right">
                                            Date
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in items" :key="i">
                                        <td>#{{item.serial}}</td>
                                        <td>
                                            <div v-if="item.type === 'recharge'">
                                                Wallet Recharge
                                            </div>
                                            <div class="details-text" v-else-if="item.type === 'class_payment'">
                                                Class: <v-btn v-if="item.class.is_program_class ? (item.class.program) : (item.class.enrollment && item.class.enrollment.course)" class="px-1" color="strong-text" style="text-decoration: underline; text-transform: none;" :to="item.class.is_program_class ? (item.class.program ? {name: 'program', params: {id: item.class.program.id}} : '') : (item.class.enrollment && item.class.enrollment.course ? {name: 'course', params: {id: item.class.enrollment.course.id}} : '')" text small>
                                                    {{item.class.is_program_class ? (item.class.program ? item.class.program.name : 'Program Class') : (item.class.enrollment && item.class.enrollment.course ? item.class.enrollment.course.name : '')}}
                                                </v-btn>
                                                <span v-else>{{item.class.is_program_class ? 'Program Class' : 'Class'}}</span>
                                            </div>
                                            <div class="details-text d-flex" v-else-if="item.type === 'admin_balance_update'" style="white-space: normal;">
                                                <div><span>Support: </span> <span class="strong-text--text">{{item.comment}}</span></div>
                                            </div>
                                            <div v-else>
                                                {{ item.comment || item.type }}
                                            </div>
                                        </td>
                                        <td>
                                            <span v-if="item.type === 'recharge'" class="font-weight-bold green--text text--darken-1">+ {{moneyFormat(item.amount)}}</span>
                                            <span v-else-if="item.type === 'class_payment'" class="font-weight-bold primary--text">- {{moneyFormat(item.value)}}</span>
                                            <span v-else-if="item.isWalletLog">
                                                <span v-if="item.value >= 0" class="font-weight-bold success--text text--darken-1">+ {{moneyFormat(item.value)}}</span>
                                                <span v-if="item.value < 0" class="font-weight-bold primary--text">- {{moneyFormat(-1 * item.value)}}</span>
                                            </span>
                                            <span v-if="item.balance_after" class="details-text ms-2 muted--text">(Balance: {{moneyFormat(item.balance_after)}})</span>
                                        </td>
                                        <td class="text-right">{{dateTimeFormat(item.timestamp, true)}} <span class="muted--text">({{item.created_at_readable}})</span></td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>

                        <div v-else-if="!loading">
                            <v-alert color="grey" text>
                                You have no transactions yet.
                            </v-alert>
                        </div>
                    </v-card-text>
                </v-card>
            </v-container>
        </transition>

        <v-dialog transition="slide-y-transition" v-if="walletData" v-model="rechargeDialog" scrollable max-width="550">
            <v-card flat style="max-width: 625px" :class="{'bordered px-3': pcOnly}">
                <v-card-title>Recharge</v-card-title>
                <v-btn icon absolute top right @click="rechargeDialog = false;">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-card-text class="mt-2">

                    <v-form @submit.prevent class="mb-4">
                        <v-text-field v-model="rechargeAmount" :loading="recharging" :disabled="recharging" color="primary" filled hide-details class="recharge-input font-weight-medium" type="number" label="Amount" placeholder="Amount in USD" prefix="$" :min="minRechargeAmount" @blur="checkAmount"></v-text-field>
                    </v-form>
                    <v-alert v-if="amountResponse" dense text color="grey" class="text--text medium-text" :style="converting ? 'opacity: 0.7' : ''">
                        You'll pay approximately <strong>≈ {{ amountResponse.total }}</strong> (including all necessary fees.)
                    </v-alert>
                    <v-btn v-if="walletData.month_estimation && !rechargeAmount" outlined block small color="primary" class="my-3" @click="rechargeAmount = parseFloat(walletData.month_estimation)">
                        Click here to recharge for 1 month <span class="font-weight-semibold me-1">( ${{ walletData.month_estimation }} )</span>
                    </v-btn>
                    <v-list>
                        <v-subheader class="text--text px-2">Choose payment method:</v-subheader>
                        <v-list-item v-for="method in paymentMethods" :key="method.value" :disabled="recharging || rechargeAmount < minRechargeAmount" :class="{'v-list-item--active': selectedMethod === method.value, 'bordered': selectedMethod !== method.value, [`primary--text`]: selectedMethod === method.value}" class="method-item rounded py-0 mb-2 overflow-hidden" v-ripple="{class: 'd-none'}" @click="selectedMethod = method.value">
                            <v-list-item-icon class="me-3 my-auto">
                                <!-- <v-radio v-model="selectedMethod" :color="method.color || 'primary'" :value="method.value" /> -->
                                <v-btn icon :color="selectedMethod === method.value ? 'primary' : 'text'" style="margin-top: -4px">
                                        <v-icon v-if="selectedMethod === method.value">mdi-checkbox-marked</v-icon>
                                        <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                                </v-btn>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title class="d-flex justify-space-between align-center mb-0" style="line-height: 0!important;">
                                    <div class="flex-grow-1">
                                        <img v-if="method.img" :src="method.img" style="width: auto" :style="`height: ${method.height}; max-width: ${method.maxWidth}`" />
                                        <v-icon v-else-if="method.icon" size="28" :color="'primary'" class="ms-1">{{method.icon}}</v-icon>
                                    </div>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item v-if="capRunning" @click="openWeb" dense class="method-item rounded py-0 mt-3 overflow-hidden grey lighten-3">
                            <v-list-item-icon class="me-3">
                                <v-icon color="indigo" style="transform: rotate(-90deg)">mdi-open-in-new</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title class="d-flex justify-space-between align-center mb-0">
                                    <div class="flex-grow-1 details-text">
                                        More methods are available on <strong>Web</strong>
                                    </div>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <v-expand-transition appear>
                        <div v-if="selectedMethod" class="mb-2 mt-6">
                            <div v-if="selectedMethod === 'paypal'" >
                                <!-- <v-btn text small color="muted" class="mt-2 mb-2" dense @click="coursesPricesDialog = true" style="text-transform: none">Don't know how much to recharge?</v-btn> -->

                                <div class="mt-4">
                                    <paypal-buttons :disabled="recharging || rechargeAmount < minRechargeAmount || !amountResponse" :amount="amountResponse.total_in_usd" @captured="completeRecharge" @error="showMsg('Error occurred during processing your payment, plase contact support.')" />
                                </div>
                            </div>
                            <div v-else-if="selectedMethod === 'stripe'" class="mb-4">
                                <stripe-form key="stripe" :disabled="recharging || rechargeAmount < minRechargeAmount" :amount="rechargeAmount" :email="user.email" />
                            </div>
                            <div v-else-if="selectedMethod === 'stripe_fpx'" class="mb-4">
                                <stripe-form key="fpx" :disabled="recharging || rechargeAmount < minRechargeAmount" :amount="rechargeAmount" :email="user.email" method="fpx" />
                            </div>
                        </div>
                    </v-expand-transition>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog transition="slide-y-transition" v-model="coursesPricesDialog" scrollable max-width="350">
            <v-card>
                <v-card-title class="mb-2">How much to recharge?</v-card-title>
                <v-card-subtitle>Info about your courses may help you decide how much to recharge. A recharge of 4, 5 weeks or more is preferred.</v-card-subtitle>
                <v-card-text class="px-3">
                    <v-list two-line class="pa-0">
                        <v-list-item v-for="course in myCourses" :key="course.id">
                            <v-list-item-avatar tile width="50">
                                <v-img :src="course.image_url"></v-img>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title style="line-height: normal!important">{{moneyFormat(course.weekly_price)}} / week</v-list-item-title>
                                <v-list-item-subtitle>Weekly Cost</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import PaypalButtons from '@/components/custom/paypal-buttons'
import StripeForm from '@/components/custom/stripe-form'
import linkifyHtml from 'linkifyjs/lib/linkify-html';
import { debounce } from 'lodash';

export default {
    name: "Wallet",
    components: {
        PaypalButtons,
        StripeForm
    },
    data(){
        return {
            loading: false,
            loadingTransactions: false,
            walletData: null,

            amountResponse: null,
            converting: false,

            rechargeDialog: false,

            success: false,

            rechargeAmount: '',
            recharging: false,

            coursesPricesDialog: false,

            selectedMethod: '',

            payMessage: '',
            payAttachment: null,

        }
    },
    computed: {
        ...GlobalComputed,
        paymentMethods(){
            let methods = this.walletData.payment_methods;
            if (this.capRunning){
                methods = methods.filter(method=>method.name !== 'paypal'); // paypal not supported on apps
            }
            return methods.map(method=>{
                return {value: method.name, subtitle: method.text, img: method.logo, icon: method.icon, reward: method.reward, steps: method.steps, height: method.height || '35px', maxWidth: method.maxWidth || '80px'};
            });
        },
        selectedPaymentMethod(){
            return this.paymentMethods.find(method=>method.value === this.selectedMethod);
        },
        myCourses(){
            return this.user.my_courses;
        },
        minRechargeAmount(){
            return this.walletData ? parseFloat(this.walletData.min_recharge_amount) : 0;
        },
        paymentHistoryData(){
            return this.$store.state.historyModule.paymentHistoryData;
        },
        items(){
            if (!this.paymentHistoryData){
                return [];
            }
            
            let recharges = this.paymentHistoryData.recharges || [];
            recharges = recharges.map(recharge=>{recharge.type = 'recharge'; return recharge;});
            
            let class_payments = this.paymentHistoryData.class_payments || [];
            class_payments = class_payments.map(payment=>{payment.type = 'class_payment'; return payment;});

            let wallet_logs = this.paymentHistoryData.wallet_logs || []; // it has it's type property, as logs not the same type
            wallet_logs = wallet_logs.map(log=>{log.isWalletLog = true; return log;});

            let items = [...wallet_logs, ...recharges, ...class_payments];
            return items.sort((a, b)=>{
                if (a.timestamp - b.timestamp !== 0){
                    return a.timestamp - b.timestamp;
                }else{
                    return a.serial - b.serial;
                }
            }).reverse(); // reverse means 'Desc' not 'Asc'
        },
    },
    methods: {
        openWeb(){
            return window.open('https://portal.ulumalazhar.com', '_system');
        },
        loadData(){
            if (!this.loading){
                this.loading = true;
                this.$store.dispatch('fastGetAction', {url: '/wallet'}).then(response=>{
                    this.loading = false;
                    const data = response.data.data;
                    this.walletData = data;

                }).catch(()=>{
                    this.loading = false;
                    this.showMsg('Error occurred during fetching data', 'error');
                })
            }
        },
        loadTransactionsData(){
            if (!this.loadingTransactions){
                this.loadingTransactions = true;
                this.$store.dispatch('loadTransactionsData').then(()=>{
                    this.loadingTransactions = false;
                }).catch(()=>{
                    this.loadingTransactions = false;
                    this.showMsg('Error occurred during fetching data', 'error');
                })
            }
        },
        getAmountInLocalCurrency(amount){
            this.converting = true;
            window.axios.get('/wallet/currency-conversion?amount=' + amount).then(response=>{
                this.amountResponse = response.data;
                this.converting = false;
            }).catch(e=>{
                this.showMsg('Error occurred during initializing payment', 'error');
                this.converting = false;
                console.error(e)
            })
        },
        checkAmount(){
            if (this.rechargeAmount && this.rechargeAmount < this.minRechargeAmount){
                this.showMsg(`Cannot recharge less than ${this.minRechargeAmount}$`, 'error');
            }
        },
        completeRecharge(captureResponse){
            const data = {
                order_id: captureResponse.id
            };
            this.recharging = true;
            this.$store.dispatch('completeRecharge', {data}).then(()=>{
                this.rechargeAmount = '';
                this.recharging = false;
                // this.showMsg('You have successfully recharged your wallet', 'success');
                this.success = true;
                this.rechargeDialog = false;
                this.$store.dispatch('updateNotifications');
            }).catch(e=>{
                this.showMsg('Error occurred during completing your payment, please contact support');
                this.recharging = false;
            });
        },
        rechargeReset(){
            this.rechargeAmount = '';
            this.payMessage = null;
            this.payAttachment = null;
            this.selectedMethod = '';
        },
        escapeHtmlText(text){
            // to prevent XSS attacks
            return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
        },
        urlify(text){
            const options = { defaultProtocol: 'https' , target: '_system', validate: {email: value=>false}};
            return linkifyHtml(text, options);
        },
        parseSteps(text){
            let html = this.escapeHtmlText(text);
            html = text.replaceAll(/\*\*.*?\*\*?/ig, match=>{
                return `<strong class="steps-strong">${match.replaceAll('**', '')}</strong>`;
            });
            html = html.replaceAll('{AMOUNT}', `<strong class="amount-strong">$${this.rechargeAmount}</strong>`);

            html = this.urlify(html);
            return html
        },
        ...GlobalMethods,
    },
    watch: {
        rechargeAmount: debounce(function(val) {
            if (!val) return;
            this.getAmountInLocalCurrency(val);
        }, 500),
    },
    mounted(){
        if (this.appData && !this.appData.enable_app_w){
            this.$router.push('/not-found');
        }else{
            if (this.$route.query && this.$route.query.success){
                this.success = true;
            }
            if (this.$route.query && this.$route.query.recharge){
                window.setTimeout(()=>{
                    this.rechargeDialog = true;
                }, 200);
            }
            this.loadData();

            if (!this.paymentHistoryData.recharges || !this.paymentHistoryData.class_payments){
                this.loadTransactionsData();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.method-item{
    &.v-list-item--disabled{
        opacity: 0.6;
        filter: grayscale(0.8);
    }
    &:active{
        opacity: 0.8;
    }
    &::before{
        opacity: 0!important;
    }
    &.v-list-item--active{
        border: 1px solid;
    }
}
</style>
<style lang="scss">
    .manual-steps{
        a{
            font-weight: bold;
        }
        .steps-strong, .amount-strong{
            padding: 2px 6px;
            border-radius: 8px;
        }
        .steps-strong{
            background: #eee;
        }
        .amount-strong{
            background: #f7f0df;
            color: #e67d00;
        }
    }
    .recharge-input{
        /* Chrome, Safari, Edge, Opera */
        input{
            &::-webkit-outer-spin-button,
            &::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }
    
            /* Firefox */
            &[type=number] {
                -moz-appearance: textfield;
            }
        }
    }
</style>